<template>
  <div style="text-align: center;">
    <div v-if="this.loadingFormSubmit == true" class="loader">Loading...</div>
    
    <div v-if="this.loadingFormSubmit == false">
      <div 
          style="width: fit-content; margin: auto;"
      >
          <el-input 
              style="    
                    width: 250px;
                    margin: 25px 25px 10px;" 
              placeholder="Give your role a name"
              v-model="permissionModelResponse.rolename">
          </el-input>
        
          <p v-if="noName == true" style="font-size: 13px; color: red; text-align: left; margin: 0px 0px 6px 50px;">Name is required </p>
      </div>
      
      <el-card
        class="privileges"
        style=""
      >
        <el-table :data="this.permissions">
  
            <el-table-column prop="privilegename">
            </el-table-column>

            <el-table-column >
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.allowed"
                  active-color="#13ce66"
                  inactive-color="#ff4949">
                ></el-switch>
              </template>
            </el-table-column>

        </el-table>
      </el-card> 

      <div  class="buttons-parent">
        <el-button
          style=" 
              background-color: #02746E; 
              color: white;"
            @click.native="editRolesPermissions()"
        > Save role
        </el-button>

        <el-button
        @click.native="closeForm()"
        >Cancel
        </el-button>
      </div>
    </div>

  </div>
</template>

<script>
import EventService from "@/services/EventService.js";
import fab from "vue-fab";

export default {
    data(){
 return{
  permissions: null,
  permissionModelResponse: [], 
  noName: false,
  loadingFormSubmit: false
 }
},
components:{
fab
},
 props: {
   roleToEdit: Object
},
methods:{
    editRolesPermissions(){

       if(this.permissionModelResponse.rolename == null || !this.permissionModelResponse.rolename.replace(/\s/g, ''))
       {
          this.noName = true;
          return
       } 
       else
       {
           this.noName = false;
       }

    //     //return rolename null if it wasn't changed
    //     var rolenameToPost;
    //  if(this.permissionModelResponse.rolename == this.$options.originalRoleName){
    //   rolenameToPost = "#"
    // } else {
    //     rolenameToPost = this.permissionModelResponse.rolename;
    // }
            
      this.loadingFormSubmit = true;

      EventService.editPriviligesOfRole(this.permissionModelResponse.roleid, this.permissionModelResponse.rolename, this.permissionModelResponse).then ( () => {
          
          var updateLocalPackage = [this.roleToEdit, this.permissionModelResponse];

          this.$emit("role-edited", updateLocalPackage)
          
          this.$store.dispatch("addNotification", {
              type: "success",
              Message: "Role saved"
          });

          this.closeForm();
      })
          .catch(error => {
              console.log(error);
              this.closeForm();
          });
    },
    closeForm(){
      this.$emit("close-edit-form")
    },
  },

created(){
   EventService.getSingleRoleDetails(this.roleToEdit.roleid).then( response => {
       this.permissionModelResponse = response.data;
   this.permissions = response.data.privilegelist;
   });
}

}
</script>

<style scoped>
.buttons-parent{
 width: 50%;
  margin: auto;
  }

.privileges{
    width: 50%;
    margin: auto auto 30px;
    height: calc(100vh - 230px);
    overflow-y: scroll;
}

@media (min-width: 250px) and (max-width: 979px) {

.privileges{
   width: 100%;
    height: calc(100vh - 300px);
}
.buttons-parent{
 width: unset;
  margin: auto;
  }
}
</style>